import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
// import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { countries } from 'countries-list'
// import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import Select from "react-select"
import ReactQuill from "react-quill";
const address = require('@bangladeshi/bangladesh-address')

//toast.configure({ autoClose: 2000 })
const Create = () => {
    const navigate = useNavigate()
    const [error, setError] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [faqs, setFaqs] = useState([]);
    const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
    const [description, setDescription] = useState("");
    const countryList = Object.values(countries);
    const [country, setCountry] = useState(null);
    const [district, setDistrict] = useState();
    const handleChange = (content) => {
    setDescription(content);
    // console.log(content);
    
    // if (onChange) onChange(content);
  };

    const [images, setImages] = useState([]);
    const rawDistict = address.allDistict();
        const all_Distict = rawDistict.map(div => ({
                value: div,
                label: div
            }));

        //  Add FAQ
        const addFaq = () => {
            if (!newFaq.question.trim() || !newFaq.answer.trim()) return alert("Please enter both question and answer!");
            setFaqs([...faqs, newFaq]);
            setNewFaq({ question: "", answer: "" });
        };
    
        // ✅ Remove FAQ
        const removeFaq = (index) => {
            const updatedFaqs = faqs.filter((_, i) => i !== index);
            setFaqs(updatedFaqs);
        };
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 500) {
                setError({ ...error, image: 'Select less than 300KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setError({ ...errors, image: null })
        }
    }

    const [galleryImages, setGalleryImages] = useState([]);

    const handleMultipleImages = (e) => {
        const files = Array.from(e.target.files);

        const mapped = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setGalleryImages((prev) => [...prev, ...mapped]);
    };

    const removeImage = (index) => {
        setGalleryImages((prev) => prev.filter((_, i) => i !== index));
    };


    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!selectedFile) return setError({ ...error, image: 'Image is required' })

            setLoading(true)
            let formData = new FormData()
            formData.append('metaTitle', data.metaTitle)
            formData.append('metaDescription', data.metaDescription)
            formData.append('title', data.title)
            formData.append('subBannerTitle', data.subBannerTitle)
            formData.append('bannerShortDescription', data.bannerShortDescription)
            formData.append('bannerShortDescriptionBangla', data.bannerShortDescriptionBangla)
            formData.append('brightGroomName', data.brightGroomName)
            formData.append('country', country)
            formData.append('district', district)
            formData.append('areaName', data.areaName)
            formData.append('joinedDate', data.joinedDate)
            formData.append('description', description)
            formData.append('image', selectedFile.image)
            formData.append('faq', JSON.stringify(faqs));
            galleryImages.forEach((img) => {
                formData.append("galleryImages", img.file);
            });
            await Requests.Story.Store(formData, header)
            setLoading(false)
            navigate('/dashboard/website/story')
        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="store-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Store story</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/story"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    

                                     {/*  Meta Title */}
                                        <div className="col-12">
                                            <div className="form-group mb-4">
                                                {errors.metaTitle && errors.metaTitle.message ? (
                                                    <p className="text-danger">{errors.metaTitle && errors.metaTitle.message}</p>
                                                ) : <p>Meta Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="metaTitle"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Meta Title"
                                                    {...register("metaTitle", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* metaDescription */}
                                        <div className="form-group mb-4">
                                            {errors.metaDescription && errors.metaDescription.message ? (
                                                <p className="text-danger">{errors.metaDescription && errors.metaDescription.message}</p>
                                            ) : <p>Meta Description</p>}

                                            <textarea
                                                type="text"
                                                name="metaDescription"
                                                rows={5}
                                                className="form-control shadow-none"
                                                placeholder="Enter Meta Description"
                                                {...register("metaDescription", { required: "Description is required" })}
                                            />
                                        </div>

                                        <div className="row">

                                        {/* Title */}
                                        <div className="col-12 col-lg-12">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Title"
                                                    {...register("title", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* link */}
                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.link && errors.link.message ? (
                                                    <p className="text-danger">{errors.link && errors.link.message}</p>
                                                ) : <p>Link</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="link"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter link"
                                                    {...register("link", { required: "link is required" })}
                                                />
                                            </div>
                                        </div> */}


                                    </div>

                                    {/* description */}
                                    <div className='row'>
                                        
                                        <div className="col-12 col-lg-12">
                                            <div className="form-group mb-4">
                                                {errors.subBannerTitle && errors.subBannerTitle.message ? (
                                                    <p className="text-danger">{errors.subBannerTitle && errors.subBannerTitle.message}</p>
                                                ) : <p>Sub banner title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="subBannerTitle"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Sub banner title"
                                                    {...register("subBannerTitle", { required: "Sub banner title is required" })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mb-4">
                                        {errors.bannerShortDescription && errors.bannerShortDescription.message ? (
                                            <p className="text-danger">{errors.bannerShortDescription && errors.bannerShortDescription.message}</p>
                                        ) : <p>Banner Short Description</p>}

                                        <textarea
                                            type="text"
                                            name="bannerShortDescription"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Banner Short Description"
                                            {...register("bannerShortDescription", { required: "Banner Short Description is required" })}
                                        />
                                    </div>
                                    
                                    <div className="form-group mb-4">
                                        {errors.bannerShortDescriptionBangla && errors.bannerShortDescriptionBangla.message ? (
                                            <p className="text-danger">{errors.bannerShortDescriptionBangla && errors.bannerShortDescriptionBangla.message}</p>
                                        ) : <p>Banner Short Description(Bangla)</p>}

                                        <textarea
                                            type="text"
                                            name="bannerShortDescriptionBangla"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Banner Short Description(Bangla)"
                                            {...register("bannerShortDescriptionBangla", { required: "Banner Short Description(Bangla) is required" })}
                                        />
                                    </div>

                                    <div className='row'>
                                        <div className="col-12 col-lg-12">
                                            <div className="form-group mb-4">
                                                {errors.brightGroomName && errors.brightGroomName.message ? (
                                                    <p className="text-danger">{errors.brightGroomName && errors.brightGroomName.message}</p>
                                                ) : <p>Bright vs Groom Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="brightGroomName"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Bright vs Groom Name"
                                                    {...register("brightGroomName", { required: "Bright vs Groom Name is required" })}
                                                />
                                            </div>
                                        </div>

                                         {/*  Country Name*/}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.country && errors.country.message ? (
                                                    <p className="text-danger">{errors.country && errors.country.message}</p>
                                                ) : <p>Country Name</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={countryList.map(country => 
                                                        ({ value: country.name, label: country.name }))}
                                                    onChange={(event) => setCountry(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        
                                        {/*  District */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>District</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                     options={all_Distict}
                                                    onChange={(event) => setDistrict(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                       

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.areaName && errors.areaName.message ? (
                                                    <p className="text-danger">{errors.areaName && errors.areaName.message}</p>
                                                ) : <p>Area Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="areaName"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Area Name"
                                                    {...register("areaName", { required: "Area Name is required" })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.joinedDate && errors.joinedDate.message ? (
                                                    <p className="text-danger">{errors.joinedDate && errors.joinedDate.message}</p>
                                                ) : <p>Joined Date</p>
                                                }

                                                <input
                                                    type="date"
                                                    name="joinedDate"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Joined Date"
                                                    {...register("joinedDate", { required: "Joined Date is required" })}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* description */}
                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Description</p>

                                        <ReactQuill
                                            value={description}
                                            onChange={handleChange}
                                            theme="snow"
                                            rows={5}
                                            className="bg-white"
                                        />
                                    </div>
                                    {/* <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>Description</p>}

                                        <textarea
                                            type="text"
                                            name="description"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short description"
                                            {...register("description", { required: "Description is required" })}
                                        />
                                    </div> */}
                                    

                                     {/* FAQ*/}
                                    <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>FAQ </p>}

                                        {faqs.length > 0 ? (
                                            faqs.map((faq, index) => (
                                                <div key={index} className="border rounded p-3 mb-3 bg-light">
                                                    <h6 className="fw-semibold mb-2">
                                                        {index + 1}. {faq.question}
                                                    </h6>
                                                    <p className="mb-2">{faq.answer}</p>
                                                    <div className='flex justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => removeFaq(index)}
                                                    >
                                                        Remove
                                                    </button></div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-muted">No FAQs added yet.</p>
                                        )}

                                        {/* ✅ Add New FAQ */}
                                        <div className="border rounded p-3 bg-white">
                                            <h6 className="fw-semibold mb-3">Add New FAQ</h6>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Enter question"
                                                value={newFaq.question}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, question: e.target.value })
                                                }
                                            />
                                            <textarea
                                                className="form-control mb-2"
                                                rows={3}
                                                placeholder="Enter answer"
                                                value={newFaq.answer}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, answer: e.target.value })
                                                }
                                            />
                                            <div className="btn btn-success" onClick={addFaq}>
                                                Add FAQ
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Gallery Images */}
                                    <div className="form-group mb-4">
                                        {error && error.galleryImages ? (
                                            <p className="text-danger">{error.galleryImages}</p>
                                        ) : (
                                            <p>Gallery Images</p>
                                        )}

                                        <div className="d-flex flex-wrap gap-2">

                                            {/* Preview images */}
                                            {galleryImages.map((img, index) => (
                                                <div key={index} className="text-center mr-2 position-relative">
                                                    <div className="image border">
                                                        <img
                                                            src={img.preview}
                                                            alt="Preview"
                                                            className="img-fluid rounded"
                                                            style={{ width: 120, height: 120, objectFit: "cover" }}
                                                        />
                                                    </div>

                                                    {/* Remove button */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger position-absolute"
                                                        style={{ top: "-8px", right: "-8px" }}
                                                        onClick={() => removeImage(index)}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}

                                            {/* Upload button */}
                                            <div className="text-center position-relative" style={{ width: 120, height: 120 }}>
                                                <div className="image border w-100 h-100 position-relative">
                                                    
                                                    <input
                                                        type="file"
                                                        className="upload"
                                                        multiple
                                                        onChange={handleMultipleImages}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            opacity: 0,
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            zIndex: 2,
                                                        }}
                                                    />

                                                    <div className="d-flex justify-content-center align-items-center h-100 w-100"
                                                        style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
                                                    >
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        height: 40,
        fontSize: 13,
        color: "#000",
        minWidth: 170,
        boxShadow: "none",
        "&:hover": { borderColor: "1px solid #ced4da" },
        border: state.isFocused ? "1px solid #dfdfdf" : "1px solid #ced4da",
        borderRadius: 0,
    }),
    menuPortal: base => ({ ...base, zIndex: 999 })
};